import React, { useState } from "react";
import { Modal, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddBoxIcon from "@mui/icons-material/AddBox";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import FromCompanyUploadFromTemplate from "./FromCompanyUploadFromTemplate";
import FromComapanyAddProject from "./FromCompanyAddProject";
import FromCompanyDownloadTemplate from "./FromCompanyDownloadTemplate";

function FromCompanyTemplate({
  openTemplateModal,
  setOpenTemplateModal,
  SetDataBaseUpdate,
  columns,
}) {
  const [openAddModal, setOpenModal] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  //--------------------------------------------------------------------------------
  //handle clik for the DownladTempalte
  //--------------------------------------------------------------------------------

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  //--------------------------------------------------------------------------------
  //handle clik for the add project button
  //--------------------------------------------------------------------------------
  const handleClickAddCourse = () => {
    setOpenModal(true);
    handleModalClose();
  };

  //--------------------------------------------------------------------------------
  //Close the Template modal
  //--------------------------------------------------------------------------------
  const handleModalClose = () => {
    setOpenTemplateModal(false);
  };

  return (
    <div>
      <Modal
        open={openTemplateModal}
        onClose={handleModalClose}
        className="course-template-modal"
      >
        {/* _________________________Header_______________________ */}
        <div className="course-template-modal-container">
          <div className="course-name-template-container-with-content">
            <IconButton
              id="button-zoom"
              className="course-name-template-close-button"
              onClick={handleModalClose}
            >
              <CloseIcon className="course-name-template-close-button-x" />
            </IconButton>
            <h5 className="course-name-template-header">Company Management</h5>
            {/* _________________________End_______________________ */}
            {/* _________________________Button,upload,download,add_______________________ */}
            <div className="course-name-template-add-course-icon">
              <div onClick={handleClickAddCourse}>
                <AddBoxIcon
                  className="course-name-template-addboxixon-style"
                  color="primary"
                  fontSize="large"
                />

                <div>
                  Add<br></br> Details
                </div>
              </div>

              <div onClick={handleMenuOpen}>
                <FileDownloadIcon
                  className="course-name-template-addboxixon-style"
                  color="primary"
                  fontSize="large"
                />

                <div>
                  Download <br></br>Template
                </div>
              </div>

              <div>
                <FromCompanyUploadFromTemplate
                  DBApi="/from-company-upload"
                  update={SetDataBaseUpdate}
                  close={handleModalClose}
                />
              </div>
            </div>
          </div>
        </div>
        {/* ___________________________end_____________________________________ */}
      </Modal>

      {/* __________________________Add Manually projectname_____________________ */}
      <FromComapanyAddProject
        openModal={openAddModal}
        setOpenModal={setOpenModal}
        SetDataBaseUpdate={SetDataBaseUpdate}
      />
      {/* ________________________________end_____________________________________*/}

      {/* __________________________Download Template ___________________________ */}

      <FromCompanyDownloadTemplate
        columns={columns}
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
      />
      {/* ________________________________end_____________________________________*/}
    </div>
  );
}

export default FromCompanyTemplate;
